import React from "react";

import { NotificationSnackbar, Tabs } from "shared/ui";

import { TARIFF_TABS } from "features/Tariff/constants";
import { TariffContext } from "features/Tariff/context";
import { useTariffState } from "features/Tariff/hooks/useTariffState";
import { BillingDetailsTab } from "features/Tariff/components/tabs/BillingDetailsTab";
import { CurrentTariffTab } from "features/Tariff/components/tabs/CurrentTariffTab";
import { PlansTab } from "features/Tariff/components/tabs/PlansTab";
import { PaymentDialog } from "features/Tariff/components/PaymentDialog";

import { Container, Placeholder, TabsRow } from "./styles";

export const Tariff = () => {
    const state = useTariffState();

    if (state.loading) {
        return <Placeholder>Загрузка тарифа…</Placeholder>;
    }

    if (state.error || !state.tariff) {
        return <Placeholder>Не удалось загрузить данные тарифа</Placeholder>;
    }

    const renderTab = () => {
        if (state.activeTab === "billing") return <BillingDetailsTab />;
        if (state.activeTab === "plans") return <PlansTab />;

        return <CurrentTariffTab />;
    };

    return (
        <TariffContext.Provider value={state}>
            <Container>
                <TabsRow>
                    <Tabs
                        value={state.activeTab}
                        tabs={TARIFF_TABS}
                        onChange={state.setActiveTab}
                    />
                </TabsRow>

                {renderTab()}

                <PaymentDialog />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </TariffContext.Provider>
    );
};
